// Admin-user management API wrappers (calls /api/admin/users). Admin-only.

import { deleteData, getData, patchData, postData } from '../../lib/api-client';
import type { AdminRole } from '../auth/auth.store';

export interface AdminUser {
  id: string;
  username: string;
  role: AdminRole;
  isActive: boolean;
  lastLoginAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface AdminUserListQuery {
  page?: number;
  limit?: number;
  search?: string;
  sort?: string;
}

export interface AdminUserListResponse {
  data: AdminUser[];
  meta: { total: number; page: number; limit: number };
}

export interface CreateAdminUserInput {
  username: string;
  password: string;
  role: AdminRole;
  isActive?: boolean;
}

// On edit: username/role/isActive optional; password optional (blank = keep).
export type UpdateAdminUserInput = Partial<CreateAdminUserInput>;

export function listAdminUsers(query: AdminUserListQuery): Promise<AdminUserListResponse> {
  return getData<AdminUserListResponse>('/admin/users', { params: query });
}

export function createAdminUser(input: CreateAdminUserInput): Promise<{ data: AdminUser }> {
  return postData('/admin/users', input);
}

export function updateAdminUser(id: string, input: UpdateAdminUserInput): Promise<{ data: AdminUser }> {
  return patchData(`/admin/users/${id}`, input);
}

export function deleteAdminUser(id: string): Promise<void> {
  return deleteData(`/admin/users/${id}`);
}
